<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="reservation__details container-fluid">
    <div class="reservation__details__content d-grid">
        <div
            class="reservation__details__content__first container-fluid px-4 py-3"
        >
            <div class="row d-flex align-items-start">
                <div
                    class="office d-flex flex-column col justify-content-center"
                >
                    <p class="office__title mb-2">
                        {{
                            'fe_details_step5_reservation_details_office_title'
                                | translate
                        }}
                    </p>
                    <p
                        class="office__text"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.branchPickup?.branchName
                        }}
                    </p>
                    <p
                        class="office__text"
                        *ngIf="
                            !reservationDetails ||
                            reservationDetails?.data?.reservationDetails
                                ?.branchPickup?.id !==
                                reservationDetails?.data?.reservationDetails
                                    ?.branchReturn?.id
                        "
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.branchReturn?.branchName
                        }}
                    </p>
                    <a
                        class="office__href mb-3"
                        queryParamsHandling="preserve"
                        [routerLink]="[]"
                        fragment="sucursal"
                        >{{
                            'fe_details_step5_reservation_details_office_href'
                                | translate
                        }}</a
                    >
                </div>
                <div
                    class="dates d-flex flex-column col justify-content-center"
                >
                    <p class="dates__title mb-2">
                        {{
                            'fe_details_step5_reservation_details_dates_title'
                                | translate
                        }}
                    </p>
                    <p class="dates__subtitle">
                        {{
                            'fe_details_step5_reservation_details_dates_subtitle'
                                | translate
                        }}
                    </p>
                    <p
                        class="dates__text"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.pickupDate
                                | date: 'dd MMM yyyy, hh:mm aa'
                                | titlecase
                        }}
                    </p>
                    <p class="dates__subtitle">
                        {{
                            'fe_details_step5_reservation_details_dates_subtitle2'
                                | translate
                        }}
                    </p>
                    <p
                        class="dates__text"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.returnDate
                                | date: 'dd MMM yyyy, hh:mm aa'
                                | titlecase
                        }}
                    </p>
                </div>
            </div>
        </div>
        <div
            class="reservation__details__content__second container-fluid px-4 py-3"
        >
            <div class="client__info d-flex flex-column">
                <p class="client__info__title mb-2">
                    {{
                        'fe_details_step5_reservation_details_client_info_title'
                            | translate
                    }}
                </p>
                <p
                    class="client__info__text"
                    [ngClass]="{
                        'placeholder placeholder-wave w-25': !reservationDetails
                    }"
                >
                    {{
                        reservationDetails?.data?.reservationDetails?.renter
                            ?.fullName
                    }}
                </p>
                <p class="client__info__text">
                    {{
                        'fe_details_step5_reservation_details_client_info_email'
                            | translate
                    }}
                    <span
                        [ngClass]="{
                            'placeholder placeholder-wave w-25':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails?.renter
                                ?.email
                        }}
                    </span>
                </p>
                <p
                    class="client__info__text"
                    *ngIf="
                        reservationDetails?.data?.reservationDetails?.renter
                            ?.phone
                    "
                >
                    {{
                        'fe_details_step5_reservation_details_client_info_phone'
                            | translate
                    }}
                    <span
                        [ngClass]="{
                            'placeholder placeholder-wave w-25':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails?.renter
                                ?.phone
                        }}
                    </span>
                </p>
            </div>
        </div>
        <div
            class="reservation__details__content__third container-fluid px-4 py-3"
        >
            <div class="vehicle d-flex">
                <div
                    class="vehicle__info d-flex flex-column justify-content-center"
                >
                    <p class="vehicle__info__title mb-2">
                        {{
                            'fe_details_step5_reservation_details_vehicle_info_title'
                                | translate
                        }}
                    </p>
                    <p
                        class="vehicle__info__subtitle"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails?.car
                                ?.name
                        }}
                    </p>
                    <p
                        class="vehicle__info__text"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{
                            reservationDetails?.data?.reservationDetails?.car
                                ?.model
                        }}
                    </p>
                    <fe-car-features
                        class="d-block mt-1 mb-2"
                        *ngIf="
                            reservationDetails?.data?.reservationDetails?.car
                                ?.features
                        "
                        [features]="
                            reservationDetails!.data!.reservationDetails!.car!
                                .features
                        "
                        [color]="'primary'"
                    ></fe-car-features>
                </div>
                <div class="vehicle__image d-flex align-items-center">
                    <img
                        [ngClass]="{
                            'placeholder placeholder-wave w-25':
                                !reservationDetails
                        }"
                        [src]="
                            reservationDetails?.data?.reservationDetails?.car
                                ?.img
                        "
                        alt="Selected car"
                    />
                </div>

                <div
                    class="vehicle__arrow align-items-center"
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.isUpgradePromotion === 1
                    "
                >
                    <img
                        [src]="'images/right_arrow_icon_blue.svg' | cdn"
                        alt="arrow-light-icon"
                        width="24"
                        height="24"
                    />
                </div>
                <div
                    class="vehicle__upgrade d-flex"
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.isUpgradePromotion === 1
                    "
                >
                    <div class="vehicle__upgrade__picture d-flex">
                        <picture>
                            <img
                                alt="img-automovil"
                                class="card__img"
                                [src]="
                                    reservationDetails?.data?.reservationDetails
                                        ?.carUpgradePromotion?.img
                                "
                            />
                        </picture>
                    </div>
                </div>
                <div
                    class="vehicle__upgrade-info d-flex"
                    *ngIf="
                        reservationDetails?.data?.reservationDetails
                            ?.isUpgradePromotion === 1
                    "
                >
                    <h4>
                        {{ 'fe_details_upgrade_promotion_title' | translate }}
                    </h4>
                    <p>
                        {{ 'fe_details_upgrade_promotion_info_1' | translate }}
                        {{
                            reservationDetails?.data?.reservationDetails?.car
                                ?.name
                        }}
                        {{ 'fe_details_upgrade_promotion_info_2' | translate }}
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.carUpgradePromotion?.name
                        }}
                        {{ 'fe_details_upgrade_promotion_info_4' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div
            class="reservation__details__content__fourth container-fluid px-4 py-3"
        >
            <div class="rent__includes d-flex flex-row align-items-center">
                <img
                    [src]="'images/car-front-sparkle-blue.svg' | cdn"
                    alt="Sparkling car"
                />
                <div class="rent__includes__div d-flex flex-row">
                    <span class="rent__includes__first"
                        >{{
                            'fe_details_step5_reservation_details_rent_includes_first'
                                | translate
                        }}
                        <p class="rent__includes__second">
                            {{
                                'fe_details_step5_reservation_details_rent_includes_second'
                                    | translate
                            }}
                        </p></span
                    >
                </div>
            </div>
            <ng-template
                ngFor
                let-insurance
                let-i="index"
                [ngForOf]="
                    reservationDetails?.data?.reservationDetails?.insurance
                "
            >
                <div
                    class="rent__insurance d-flex flex-row justify-content-between mt-2"
                    (click)="toggleInsurance(i)"
                >
                    <p
                        class="rent__insurance__text"
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !reservationDetails
                        }"
                    >
                        {{ insurance?.name }}
                    </p>
                    <div
                        class="rent__insurance__icon"
                        [ngClass]="{ insurance: isInsuranceOpen(i) }"
                    >
                        <img
                            [src]="'images/chevron-alt-down.png' | cdn"
                            alt="details"
                        />
                    </div>
                </div>
                <div
                    class="rent__insurance__hidden"
                    [innerHTML]="insurance?.description"
                    [ngClass]="{ insurance: isInsuranceOpen(i) }"
                ></div>
            </ng-template>
        </div>
        <div
            class="reservation__details__content__fifth container-fluid px-4 py-3"
            *ngIf="hasProducts"
        >
            <div class="extras d-flex flex-column">
                <p class="extras__title mb-2">
                    {{
                        'fe_details_step5_reservation_details_extras_title'
                            | translate
                    }}
                </p>
                <p
                    *ngFor="
                        let res of reservationDetails?.data?.reservationDetails
                            ?.products
                    "
                    class="extras__text"
                >
                    {{ res }}
                </p>
            </div>
        </div>
        <div
            class="reservation__details__content__sixth container-fluid px-4 py-3"
        >
            <div
                class="price__details d-flex flex-row justify-content-between"
                (click)="toggleDetails()"
            >
                <div
                    class="price__details__left d-flex flex-row align-items-center"
                >
                    <div
                        class="price__details__left__icon"
                        [ngClass]="{ details: isDetails }"
                    >
                        <img
                            [src]="'images/chevron-alt-down.png' | cdn"
                            alt="details"
                        />
                    </div>
                    <p class="price__details__left__title">
                        {{
                            'fe_details_step5_reservation_details_price_details_left'
                                | translate
                        }}
                    </p>
                </div>
                <div
                    class="price__details__right d-flex flex-row align-items-center"
                >
                    <p class="price__details__right__total">
                        {{ getPriceLabelKey() | translate }}
                    </p>
                    <p class="price__details__right__amount">
                        ${{
                            reservationDetails?.data?.reservationDetails
                                ?.totalEstimated | number: '1.2-2':'en-IN'
                        }}
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.currency
                        }}
                    </p>
                </div>
            </div>
            <div
                class="price__details__hidden"
                [ngClass]="{ details: isDetails }"
            >
                <div
                    class="d-flex flex-row justify-content-between"
                    *ngFor="
                        let res of reservationDetails?.data?.reservationDetails
                            ?.calculations
                    "
                    [ngStyle]="{
                        color: res.isDiscount ? '#1A6FE2' : 'inherit'
                    }"
                >
                    <p class="price__details__hidden__name">{{ res.name }}</p>
                    <p>
                        ${{ res.price | number: '1.2-2':'en-IN' }}
                        {{
                            reservationDetails?.data?.reservationDetails
                                ?.currency
                        }}
                    </p>
                </div>
            </div>
        </div>
        <div
            class="reservation__details__content__sixth__mobile container-fluid px-4 py-3"
        >
            <div
                class="price__details__mobile d-flex flex-row justify-content-between"
                (click)="toggleDetails()"
            >
                <div
                    class="price__details__mobile__left d-flex flex-row align-items-center"
                >
                    <p class="price__details__mobile__left__total">
                        {{ getPriceLabelKey() | translate }}
                    </p>
                    <p class="price__details__mobile__left__amount">
                        ${{
                            reservationDetails?.data?.reservationDetails
                                ?.totalEstimated | number: '1.2-2':'en-IN'
                        }}
                    </p>
                </div>
                <div class="price__details__mobile__right d-flex flex-row">
                    <div
                        class="price__details__mobile__right__icon"
                        [ngClass]="{ details: isDetails }"
                    >
                        <img
                            [src]="'images/chevron-alt-down.png' | cdn"
                            alt="details"
                        />
                    </div>
                </div>
            </div>
            <div
                class="price__details__mobile__hidden"
                [ngClass]="{ details: isDetails }"
            >
                <div
                    class="d-flex flex-row justify-content-between"
                    *ngFor="
                        let res of reservationDetails?.data?.reservationDetails
                            ?.calculations
                    "
                    [ngStyle]="{
                        color: res.isDiscount ? '#1A6FE2' : 'inherit'
                    }"
                >
                    <p class="price__details__mobile__hidden__name">
                        {{ res.name }}
                    </p>
                    <p>${{ res.price | number: '1.2-2':'en-IN' }}</p>
                </div>
            </div>
        </div>
    </div>
</section>
